import useMutation from "../useMutation";
export default function useWarehouseTransferImportSeriesUpdate(id, transferDetailId) {
  return useMutation({
    path: `/api/v1/warehouse-transfers/${id}/transfer-details/${transferDetailId}/export`,
    method: "PUT",
  });
}
